import {ComponentFactoryResolver, Injectable, ViewContainerRef, ViewRef} from '@angular/core';
import {ModalTypeTagComponent} from "../../components/modal-type-tag/modal-type-tag";

/*
  Generated class for the MyModalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MyModalProvider {

  index: number;
  viewRef: ViewRef;
  viewContainer: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    console.log('Hello MyModalProvider Provider');
  }

  /**
   * */
  public open(component, viewContainer: ViewContainerRef, data?: any){
    this.viewContainer = viewContainer;
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const c = factory.create(viewContainer.parentInjector);

    if(data){
      (c.instance)['data'] = data;
    }

    this.viewRef = c.hostView;
    viewContainer.insert(this.viewRef);
    this.index = viewContainer.indexOf(c.hostView);

  }

  /**
   * */
  public dismiss(){
    if(this.viewRef){
      this.viewRef.destroy();
      this.viewContainer.remove(this.index);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/my-modal/my-modal.ts